import styled from 'styled-components';
import { white, contiOrange } from '../../style/colors';

export const Container = styled.div`
  position: relative;
`;

export const Backdrop = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 999;
  }
`;

export const FilterButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: ${white};
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #111827;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: ${contiOrange};
    box-shadow: 0 2px 8px rgba(255, 165, 0, 0.15);
  }

  i {
    font-size: 18px;
    color: ${contiOrange};

    &:last-child {
      color: #6b7280;
      font-size: 16px;
    }
  }
`;

export const Dropdown = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  background: ${white};
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  padding: 16px;
  z-index: 1000;
  min-width: 300px;

  @media (max-width: 768px) {
    position: fixed;
    top: 50%;
    left: 50%;
    right: auto;
    transform: translate(-50%, -50%);
    max-width: 90vw;
    max-height: 90vh;
    overflow-y: auto;
  }
`;

export const PresetGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e5e7eb;
`;

export const PresetButton = styled.button`
  padding: 10px 16px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: left;

  &:hover {
    background: rgba(255, 165, 0, 0.05);
    border-color: ${contiOrange};
    color: ${contiOrange};
  }
`;

export const DatePickerWrapper = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 16px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 12px;
  }

  label {
    display: block;
    font-size: 12px;
    font-weight: 600;
    color: #6b7280;
    margin-bottom: 8px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .react-datepicker {
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    font-family: inherit;
  }

  .react-datepicker__header {
    background-color: #f9fafb;
    border-bottom: 1px solid #e5e7eb;
    border-radius: 8px 8px 0 0;
  }

  .react-datepicker__day--selected,
  .react-datepicker__day--in-range {
    background-color: ${contiOrange};
    color: ${white};
  }

  .react-datepicker__day--keyboard-selected {
    background-color: rgba(255, 165, 0, 0.2);
    color: #111827;
  }

  .react-datepicker__day:hover {
    background-color: rgba(255, 165, 0, 0.1);
  }
`;

export const ApplyButton = styled.button`
  width: 100%;
  padding: 10px 16px;
  background: ${contiOrange};
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  color: ${white};
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #ff9500;
    box-shadow: 0 4px 12px rgba(255, 165, 0, 0.3);
  }

  &:active {
    transform: scale(0.98);
  }
`;

